import React, {useState} from 'react'
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Box,
  Popover,
} from '@material-ui/core/'
import FilterListIcon from '@material-ui/icons/FilterList'
import {Query} from 'react-apollo'
import {searchObjects} from '../../graphql/barcode/queries/searchObjectsQuery'
import LoadingScreen from '../BarcodeLoadingScreen'
import ComlumnFilter from './BarcodeFieldColumnFilter'
import ArrayUnion from 'array-union'
import useStyles from './BarcodeFieldValueTable.styles'

export default function BarcodeFieldValueTable(props) {
  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage] = useState(50)
  const [totalObject, setTotalObject] = useState(0)
  const [loadingObject, setLoadingObject] = useState(true)
  const [fieldObjects, setFieldObjects] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [columnFilterSearch, setColumnFilterSearch] = useState('')
  const [objectSort, setObjectSort] = useState('')
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const [nextPageClick, setNextPageClick] = useState(false)

  console.log(fieldObjects, 'fieldObjects')
  function handleClose() {
    setAnchorEl(null)
  }

  function filterButtonClick(event, data) {
    setAnchorEl(event.currentTarget)
    setColumnFilterSearch({
      key: data.key,
      type: data.type,
      fieldId: data.id,
    })
  }

  function handleSelectAllClick(event) {
    if (event && event.target.checked) {
      const newSelecteds = props.loadedObjects
        .filter((a, i) => i >= page * 50 && i < (page + 1) * 50)
        .map(n => n)
      const selectedids = props.selected.map(n => n.id)
      let tSelected = []
      newSelecteds.forEach(n => {
        if (!selectedids.includes(n.id)) {
          tSelected.push(n)
        }
      })
      if (tSelected.length > 0) {
        props.setSelected([...props.selected, ...tSelected])
      } else {
        const newSelectedids = props.loadedObjects
          .filter((a, i) => i >= page * 50 && i < (page + 1) * 50)
          .map(n => n.id)
        let newSelected = []
        props.selected.forEach(n => {
          if (!newSelectedids.includes(n.id)) {
            newSelected.push(n)
          }
        })
        props.setSelected([...newSelected])
      }
      return
    }
    if (event && !event.target.checked) {
      const newSelectedids = props.loadedObjects
        .filter((a, i) => i >= page * 50 && i < (page + 1) * 50)
        .map(n => n.id)
      let newSelected = []
      props.selected.forEach(n => {
        if (!newSelectedids.includes(n.id)) {
          newSelected.push(n)
        }
      })
      props.setSelected([...newSelected])
      return
    }
  }

  function handleClick(event, name) {
    const selectedIndex = props.selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(props.selected.slice(1))
    } else if (selectedIndex === props.selected.length - 1) {
      newSelected = newSelected.concat(props.selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        props.selected.slice(0, selectedIndex),
        props.selected.slice(selectedIndex + 1)
      )
    }
    props.setSelected(newSelected)
  }

  function handleChangePage(event, newPage) {
    setPage(newPage)
    setNextPageClick(true)
    props.setPageOffset(newPage * 50)
  }

  function displayType(fieldDisplay, row) {
    if (row[fieldDisplay.key] === undefined || row[fieldDisplay.key] === null) {
      return '-'
    } else if (fieldDisplay.type === 'default_image') {
      return <img src={row['default_attachment']['url']} alt="default_attachment" />
    } else if (
      fieldDisplay.type === 'StatusField' ||
      fieldDisplay.type === 'ApUserField' ||
      fieldDisplay.type === 'EntityListField'
    ) {
      return row[fieldDisplay.key]['display_name']
    } else if (fieldDisplay.type === 'SignatureField') {
      return (
        <img src={row[fieldDisplay.key]} alt={fieldDisplay.key} className={classes.imageSize} />
      )
    } else if (fieldDisplay.type === 'MultipleEntityListField') {
      let values = ''
      Object.keys(row[fieldDisplay.key]).forEach(function(key) {
        if (values !== '') values = values + ', ' + row[fieldDisplay.key][key]['display_name']
        else values = row[fieldDisplay.key][key]['display_name']
      })
      return values
    } else {
      return row[fieldDisplay.key].toString()
    }
  }

  const isSelected = name => props.selected.indexOf(name) !== -1

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.divOverflow}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={props.dense === 'compress' ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                <TableCell padding="none" classes={{paddingNone: classes.cellCheckBox}}>
                  <Checkbox
                    indeterminate={
                      props.selected.length > 0 &&
                      props.selected.length < props.loadedObjects.length
                    }
                    checked={
                      props.selected.length === props.loadedObjects.length &&
                      props.loadedObjects.length !== 0
                    }
                    onChange={handleSelectAllClick}
                    inputProps={{'aria-label': 'select all desserts'}}
                  />
                </TableCell>

                {props.displayFields.map((row, index) => {
                  return row.type === 'ReservationAction' ? (
                    ''
                  ) : (
                    <TableCell
                      key={row.key}
                      align="left"
                      padding="default"
                      className={classes.textWordBreak}
                    >
                      {row.name}

                      {row.type === 'default_image' ||
                      row.type === 'StatusField' ||
                      row.type === null ||
                      row.type === 'SignatureField' ? (
                        ''
                      ) : (
                        <IconButton size="small" onClick={e => filterButtonClick(e, row)}>
                          <FilterListIcon className={classes.filterListStyle} />
                        </IconButton>
                      )}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>

            <Query
              query={searchObjects}
              variables={{
                entityId: parseInt(props.entityId),
                token: props.token,
                offset: props.pageOffset,
                search: props.search,
                filterValues: JSON.stringify(props.filterValues),
                fieldMatch: props.fieldMatch,
                fieldFilters: JSON.stringify(props.fieldFilters),
                sort: objectSort,
                userId: userId,
              }}
            >
              {({loading, error, data}) => {
                if (loading) {
                  setLoadingObject(true)
                  return (
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <LoadingScreen size={50} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  )
                }
                if (error) {
                  return <div>Error Loading Objects....</div>
                }

                if (props.loadedObjects.length === 0) {
                  props.setLoadedObjects(data['searchObjects']['objects'])
                } else if (nextPageClick) {
                  props.setLoadedObjects(
                    ArrayUnion(props.loadedObjects, data['searchObjects']['objects'])
                  )
                }
                setTotalObject(data['searchObjects']['total'])
                setFieldObjects(data['searchObjects']['objects'])

                if (data['searchObjects']['total'] <= 50) {
                  handleChangePage('event', 0)
                }
                setLoadingObject(false)
                setNextPageClick(false)

                return (
                  <TableBody className={classes.tableBody}>
                    {fieldObjects.map((row, index) => {
                      const isItemSelected = isSelected(row)
                      const labelId = `enhanced-table-checkbox-${index}`

                      return (
                        <TableRow
                          hover
                          onClick={event => handleClick(event, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="none" classes={{paddingNone: classes.cellCheckBox}}>
                            <Checkbox
                              checked={isItemSelected}
                              inputProps={{'aria-labelledby': labelId}}
                            />
                          </TableCell>

                          {props.displayFields.map((fieldDisplay, index) =>
                            index === 0 ? (
                              <TableCell
                                key={row.id + index}
                                component="th"
                                id={labelId}
                                scope="row"
                                padding="default"
                                align="left"
                                classes={{root: classes.cellRoot}}
                              >
                                {displayType(fieldDisplay, row)}
                              </TableCell>
                            ) : fieldDisplay.type === 'ReservationAction' ? (
                              ''
                            ) : (
                              <TableCell
                                align="left"
                                key={row.id + index}
                                padding="default"
                                classes={{root: classes.cellRoot}}
                              >
                                {displayType(fieldDisplay, row)}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                )
              }}
            </Query>
          </Table>
        </div>
        <TablePagination
          hidden={loadingObject}
          rowsPerPageOptions={[]}
          component="div"
          count={totalObject}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
        />
      </Paper>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <ComlumnFilter
          entityId={props.entityId}
          token={props.token}
          columnFilterSearch={columnFilterSearch}
          setObjectSort={setObjectSort}
          setFilterValues={props.setFilterValues}
          setFieldMatch={props.setFieldMatch}
          setPageOffset={props.setPageOffset}
          setLoadedObjects={props.setLoadedObjects}
          setSelected={props.setSelected}
          fieldObjects={fieldObjects}
          setFieldObjects={setFieldObjects}
        />
      </Popover>
      <Box marginBottom={5} />
    </div>
  )
}
